import * as React from 'react';
import {IocStore} from "../stores/ioc";
import {observer, useLocalObservable} from "mobx-react-lite";
import {Link, useParams} from "react-router-dom";
import {requests} from "../api";
import Backdrop from "../components/Backdrop";
import {Alert, Col, Row} from "react-bootstrap";
import {runInAction} from "mobx";

interface TokenData {
    token: string
}

const ValidatePage = observer(function ValidatePage(props: { store: IocStore }) {
    const params: { token: string } = useParams()

    const localState = useLocalObservable(() => ({
        loading: false,
        validated: false,
        error: ''
    }))

    if (!localState.loading && !localState.validated && !localState.error) {
        requests.get(`/user/validate_token/${params.token}`)
            .then((data: TokenData) => {
                props.store.setCode(data.token)
                runInAction(() => localState.validated = true)

            })
            .catch(err => runInAction(() => localState.error = err.message))
            .finally(() => runInAction(() => localState.loading = false))
    }

    return <>
        <Row>
            <Backdrop hidden={!localState.loading}/>
            <Col>
                {localState.error !== '' && <>
                    {localState.error === 'Token already activated' ?
                        <Alert variant="danger">The validation link has already been used. Click <Link to="/">here</Link> to request a new one.</Alert> :
                        <Alert variant="danger">We couldn't find this access token. Click <Link to="/">here</Link> to request a new one.</Alert>
                    }
                </>}
                {localState.validated && <>
                    <Alert variant="success">Thank you for verifying your email address. We will remember this browser. If you want to access the tool from another browser, you can re-validate your email address or use the following code: {props.store.code}</Alert>
                    <p>You can close this browser tab.</p>
                </>}
            </Col>
        </Row>
    </>
})

export default ValidatePage